<div class="general-container appear">
  
    <div 
      class="flex flex-col md:flex-row gap-x-6 items-center justify-between py-12 my-16">
      <div class="flex gap-x-12 items-center justify-start py-12 my-16 w-full">
        <p class="font-sans text-l">Mostrar:</p>
        <div class="w-full md:max-w-[280px]">
          <fun-input
            [parentForm]="searchForm"
            [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages"
            [isSubmit]="isSubmit"
            controlName="status"
            type="select"
            [errorLogin]="errorLogin"
            classExtra=" !w-full "
            [items]="values"
            [selectedItem]="initValue"
            (selectChange)="changeProject()"
          ></fun-input>
        </div>
      </div>
      <div class="flex gap-x-6 items-center justify-end py-12 my-16">
        <fun-new-button size="s" (eventClick)="changeMode('list')" icon="coin-stack" iconPosition="right" [buttonType]="mode === 'list' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.LIST' | translate }}"></fun-new-button>
        <fun-new-button size="s" (eventClick)="changeMode('calendar')" icon="calendar" iconPosition="right" [buttonType]="mode === 'calendar' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.CALENDAR' | translate }}"></fun-new-button>
      </div>
    </div>
    <div *ngIf="mode === 'calendar' && !loading" class="py-72">
      <fun-calendar-pay-timetable [calendarBenefits]="benefitsByMonth"></fun-calendar-pay-timetable>
    </div>
  <div *ngIf="benefitsByMonth && benefitsByMonth.length > 0 && !loading" class="content-container">
    <div *ngIf="benefitsByMonth && mode === 'list'" class="content-calendar">
        <ng-container *ngFor="let monthWithBenefits of benefitsByMonth;let indice=index">
            <app-calendar-pay-month [indice]="indice + 1" [monthWithBenefits]="monthWithBenefits"></app-calendar-pay-month>
        </ng-container>
    </div>
  </div>
  <div *ngIf="(!benefitsByMonth || benefitsByMonth.length === 0) && mode === 'list' && !loading"
  class="mt-[88px] flex flex-col gap-12 items-center justify-center w-full md:max-w-[720px] p-32 my-16 mx-auto">
    <!-- <img src="../../assets/images/illustrations/notifications.svg" alt="notification"> -->
    <fun-icon [name]="'coin-stack'" [style]="'w-72 h-72 stroke-[2px] stroke-orange-100'"></fun-icon>
    <p class="font-sans text-l text-eggplant-70">{{ 'PAYMENT_CALENDAR.TXT' | translate }}</p>
  </div>
  <fun-spinner *ngIf="loading"></fun-spinner>
</div>